import React from 'react';
import { injectIntl } from 'react-intl';
import ContactDetailsCard from '../components/contactDetails/index';
import useContacts from '../hooks/contacts';
import useCallInfo from '../hooks/callInfo';

const ContactRoute = injectIntl((props) => {
  const [, , , { deleteContact }] = useContacts();
  const [callInfo, { makeCall, holdCall }] = useCallInfo();

  const handleEditContactClick = (currentContact) => {
    props.history.replace(`/contacts/${currentContact.uuid}/edit`);
  };

  const handleContactDetailsClick = (actionType, data) => {
    // TODO implement delete contact hook. { contact_uuid: data, history: props.history }
    //console.log("CONTACT ROUTE - handleContactDetailsClicked ", actionType, contactUUID);
    switch (actionType) {
      case 'delete_contact':
        deleteContact(data, props.history, props.intl);
        break;

      case 'make_call':
        // if there is an active call, put it on hold
        if (callInfo.activeCallId.length > 0 && typeof callInfo.inprogressCalls[callInfo.activeCallId] !== "undefined" && callInfo.inprogressCalls[callInfo.activeCallId].isHeld === false) {
          holdCall(callInfo.activeCallId, props.intl);
        }

        makeCall(data);
        props.history.push('/callprogress');
        break;
      default:
        console.error('Unhandled action type in handleContactDetailsClick', actionType);
    }

  };

  return (
    <div className="ContactsContainer" >
      <ContactDetailsCard
        cbEditContact={handleEditContactClick}
        cbContactDetailsClick={handleContactDetailsClick}
        contactUUID={props.match.params.id}
      />
    </div>
  );
});

export default ContactRoute;